import createReactComponent from '../createReactComponent';
export default createReactComponent('corner-up-right', 'CornerUpRight', [["path",{"d":"M19 10.027H9a4 4 0 0 0-4 4V19m14-8.973-4.78 5.028M19 10.027 14.22 5","key":"svg-0"}]]);